export default "__VITE_ASSET__BqBNSpZo__"